'use strict';

angular.module('imagetrend.components')
    .directive('ckEditor', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
                height: '@?',
                toolbar: '=?',
                skin: '=?',
                remove: '=?'
            },
            link: function (scope, elm, attr, ngModel) {
                if (!ngModel) return;
                if (!scope.height) {
                    scope.height = 250;
                }
                
                if (!scope.toolbar || scope.toolbar == '' || scope.toolbar == 'full') {
                    scope.toolbar = [	
                        { name: 'clipboard',   items: [ 'Cut', 'Copy', 'Paste', 'PasteFromWord','-','Undo','Redo' ] },
                        { name: 'editing',     items : ['Find','Replace','-','SelectAll','RemoveFormat'] },
                        { name: 'paragraph',   items : ['NumberedList','BulletedList','-','Outdent','Indent','Blockquote','JustifyLeft','JustifyCenter','JustifyRight','JustifyFull'] },
                        { name: 'insert',      items : ['Image','Table','HorizontalRule','-','Link','Unlink'] },
                        '/',
                        { name: 'styles',      items : ['Bold','Italic','Underline','Strike','-','Subscript','Superscript'] },
                        { name: 'font',        items : ['Styles','Format','Font','FontSize'] },
                        { name: 'color',       items : ['TextColor','BGColor'] }			
                    ] ;
                }
                else {
                    scope.toolbar = [	
                        { name: 'styles',      items : ['Bold','Italic','Underline','Strike'] }
                    ] ;
                }

                // Set Skin
                if (!scope.skin || scope.skin == '') {
                    scope.skin = 'moono';
                }

                // Remove any plugins (mostly toolbar things)
                if (!scope.remove || scope.remove == '')
                {
                    scope.remove = 'liststyle,exportpdf,smiley,specialchar,iframe,showblocks,copyformatting,contextmenu,tabletools,tableselection';
                }
                else
                {
                    scope.remove += 'liststyle,exportpdf,smiley,specialchar,iframe,showblocks,copyformatting,contextmenu,tabletools,tableselection';
                }

                var ck = CKEDITOR.replace(elm[0], {
                    toolbar: scope.toolbar,
                    versionCheck: false,
                    forcePasteAsPlainText: true,
                    disableNativeSpellChecker: false,
                    height: scope.height,
                    skin: scope.skin,
                    removePlugins: scope.remove
                });

                ck.on('instanceReady', function () {
                    ck.setData(ngModel.$viewValue);
                });

                ck.on('change', function () {
                    var timer = $timeout(function() {
                        ngModel.$setViewValue(ck.getData());
                    }, 0);
                    scope.$on('$destroy', function () {
                        $timeout.cancel(timer);
                    });
                });

                ngModel.$render = function (value) {
                    ck.setData(ngModel.$viewValue);
                };

                elm.bind('$destroy', function () {
                    ck.destroy();
                });
            }
        }
    }])
    .directive('ckHtml', ['$sce', function ($sce) {
        return {
            restrict: 'E',
            scope: {
                htmlSrc: '@?',
                id: '@?'
            },
            transclude: true,
            template:
                '<div id="{{id}}" class="wrap keep-styling" ng-bind-html="newHtml"></div>',
            link: function (scope, elm, attr) {
                attr.$observe("htmlSrc", function () {
                    scope.newHtml = $sce.trustAsHtml(scope.htmlSrc);
                });
            }
        }
    }])
;